/* eslint-disable max-len */
import * as R from 'ramda';
import angular from 'angular';

export default function AssignControlDialogController(
  $q,
  $rootScope,
  $scope,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  controlDataService,
  controlSharedModelService,
  editControlDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditRiskControlSubmit = _handleEditRiskControlSubmit;
  vm.handleAddControlDialogClick = _handleAddControlDialogClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    $scope.$on('refreshControls', () => {
      _refreshControls();
    });
    getControlList();
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.assignControlDialog);
  }

  function _handleEditRiskControlSubmit() {
    if ($scope.assignControlForm.$valid) {
      loaderService.showViewLoader = true;
      const controls = [];
      R.forEach(
        (controlType) => {
          R.forEach(
            (item) => {
              if (item.isAssigned === true) {
                controls.push(item);
              }
            },
            controlType.customerControls
          );
        },
        vm.controlTypeList
      );
      riskDataService.saveRiskControls(vm.risk.customerRiskId, controls).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the control for risk.');
        } else {
          alerts.success('The control for risk has been saved successfully.');
          vm.saved = true;
          $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
          ssDialogService.hide(ssDialogService.dialogs.riskAdmin.assignControlDialog);
        }
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleAddControlDialogClick($event) {
    const control = { customerControlTypeId: 0 };
    const promises = [
      controlDataService.getControlTypeDefaults(),
      controlDataService.getControlTypes(),
      riskDataService.getRisks(),
      getInitControlAdmin(),
    ];
    return $q.all(promises).then((response) => {
      loaderService.showViewLoader = false;
      control.controlPreventiveEffectiveness = response[0].data.controlPreventiveEffectiveness;
      control.controlDetectiveEffectiveness = response[0].data.controlDetectiveEffectiveness;
      control.controlCorrectiveEffectiveness = response[0].data.controlCorrectiveEffectiveness;
      control.controlAdministrativeNature = response[0].data.controlAdministrativeNature;
      control.controlTechnicalNature = response[0].data.controlTechnicalNature;
      control.controlPhysicalNature = response[0].data.controlPhysicalNature;
      control.controlPrimaryControlType = response[0].data.controlPrimaryControlType;
      control.controlCompensatingControlType = response[0].data.controlCompensatingControlType;
      control.controlReviewSchedule = response[0].data.controlReviewSchedule;
      control.controlReviewType = response[0].data.controlReviewType;
      control.controlResult = response[0].data.controlResult;
      ssDialogService.dialogs.controlAdmin.editControlDialog = ssDialogService.alert(
        editControlDialog.getOptions($event, {
          control,
          controlTypes: response[1].data.result,
          risks: response[2].data.result,
          risk: vm.risk,
          controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlDialog);
    });
  }

  function getInitControlAdmin() {
    if (controlSharedModelService.ControlResults && controlSharedModelService.ControlResults.length > 0) {
      return Promise.resolve();
    }
    return controlDataService.initControlAdmin().then((getControlInitResponse) => {
      if (!getControlInitResponse.data) {
        alerts.error('Error occurred get control init data.');
      } else {
        if (getControlInitResponse.data.ControlResults) {
          controlSharedModelService.ControlResults = getControlInitResponse.data.ControlResults.result;
        }

        if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
          controlSharedModelService.ControlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
          controlSharedModelService.ControlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
          controlSharedModelService.ControlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlAdministrativeNatures) {
          controlSharedModelService.ControlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
        }

        if (getControlInitResponse.data.ControlPhysicalNatures) {
          controlSharedModelService.ControlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
        }

        if (getControlInitResponse.data.ControlTechnicalNatures) {
          controlSharedModelService.ControlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
        }

        if (getControlInitResponse.data.ControlPrimaryControlTypes) {
          controlSharedModelService.ControlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
        }

        if (getControlInitResponse.data.ControlCompensatingControlTypes) {
          controlSharedModelService.ControlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
        }

        if (getControlInitResponse.data.ControlReviewSchedules) {
          controlSharedModelService.ControlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
        }

        if (getControlInitResponse.data.ControlReviewTypes) {
          controlSharedModelService.ControlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
        }

        if (getControlInitResponse.data.ControlTypes) {
          controlSharedModelService.ControlTypes = getControlInitResponse.data.ControlTypes.result;
        }
      }
    });
  }

  function _refreshControls() {
    return controlDataService.getControls().then((results) => {
      vm.controls = results.data.result;
      getControlList();
    });
  }

  function getControlList() {
    const newControls = angular.copy(vm.controls);
    vm.savedControls = R.filter(
      (control) => {
        if (!control.customerRiskControl) {
          return control;
        }
        return false;
      },
      newControls
    );
    vm.savedControls = R.map((control) => {
      control.isAssigned = false;
      return control;
    }, vm.savedControls);

    vm.controlTypeList = controlSharedModelService.transformControlTypeList(vm.savedControls);
  }
}

AssignControlDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'controlDataService',
  'controlSharedModelService',
  'editControlDialog'
];
